import { useState } from "react";
import Card from "../UI/Card";
//? styles
import styles from "./Birthday.module.css";

//? components
import Profile from "../Profile/Profile";
const Birthday = (props) => {
  const { data } = props;
  const lastUpdate = "23rd August 2022";
  let originalLengthOfData =
    data.lengthOfData || 0;
  const [lengthOfData, setLengthOfData] =
    useState(originalLengthOfData);
  const clearDataHandler = () => {
    setLengthOfData(0);
  };
  return (
    <Card
      className={styles["birthday-container"]}
    >
      {lengthOfData >= 1 && (
        <h1
          className={
            styles["birthday-container__header"]
          }
        >
          {lengthOfData + " birthdays today"}
        </h1>
      )}
      {lengthOfData >= 1 &&
        data.realData.map((people) => {
          return (
            <Profile
              {...people}
              key={people.id}
            />
          );
        })}
      {lengthOfData < 1 && (
        <p
          className={
            styles[
              "birthday-container__no-birthday"
            ]
          }
        >
          No birthday Available
        </p>
      )}
      {lengthOfData >= 1 && (
        <button
          type="button"
          className={styles["clear-button"]}
          onClick={clearDataHandler}
        >
          Clear All
        </button>
      )}
      <p id={styles["last-update"]}>
        Last Updated: <span>{lastUpdate}</span>
      </p>
    </Card>
  );
};

export default Birthday;
